export const DISCOUNT_METHOD = {
  NONE: 'none',
  LOYALTY_POINTS: 'loyalty_points',
  COUPON: 'coupon',
};
